export default {
  title: 'Qualitätsbericht',
};
